const UUID_PATTERN = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

/**
 * Whether a value is a UUID in the 8-4-4-4-12 hex form (any version, any case).
 *
 * Use it to reject a bad route id before calling the API (NPJB-837). The zero UUID passes:
 * it has the right shape, so the backend decides whether it exists.
 */
export const isUuid = (value: unknown): value is string =>
  typeof value === 'string' && UUID_PATTERN.test(value);
